{
  "dropzoneLabel": "Droppsone",
  "selectPlaceholder": "Velg et element",
  "tableResizer": "Størrelsesendrer",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
